import React from 'react';
import NoRowsWrapper from '@/components/table/NoRowsWrapper';
import ScrollableCards from '@/components/cards/ScrollableCards';
import Breadcrumb from '@/components/breadcrumbs/Breadcrumb';
import UppyHooks from '../hooks/uppy';
import DatasetAttachmentsFilters from './DatasetAttachmentsFilters';
import DatasetAttachmentsDragDrop from './DatasetAttachmentsDragDrop';
import DatasetAttachmentCardItems from './DatasetAttachmentCardItems';
import DatasetAttachmentsAccordion from './DatasetAttachmentsAccordion';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';
import Fetch from '../hooks/fetch';
import FolderControls from './FolderControls';

const DatasetAttachmentsCards = ({ category, code }) => {
  const [accordionOpen, setAccordionOpen] = React.useState(false);
  const state = Selectors.useDatasetAttachmentsCards({ category, code });
  const fetchAttachments = Events.useFetchDatasetAttachments(category, { code });
  const startUpload = Events.useDatasetAttachmentsUpload(category, { code });
  const uploadsFail = Events.useDatasetAttachmentsUploadFail(category, { code });
  const uploadRemoved = Events.useDatasetAttachmentUploadRemoved(category, { code });
  const uploadSuccess = Events.useDatasetAttachmentUploadSuccess(category, { code });
  const onNavigate = Events.useAttachmentFolderNavigate(category, { code });

  const uppy = UppyHooks.useDatasetAttachmentsUppy(
    code,
    state,
    fetchAttachments,
    startUpload,
    uploadRemoved,
    uploadsFail,
    uploadSuccess,
    state.path,
  );

  Fetch.useFetchDatasetAttachments({ category, code, exists: state.exists }, state.readStatus);

  return (
    <DatasetAttachmentsAccordion
      active={accordionOpen}
      category={category}
      code={code}
      canUpdate={state.canUpdate}
      canUpload={state.canUpload}
      onClick={() => setAccordionOpen(!accordionOpen)}
    >
      <DatasetAttachmentsFilters code={code} category={category} fluid />
      {state.canUpload && state.storageEnabled && (
        <div className="mt-10">
          <DatasetAttachmentsDragDrop canUpload uppy={uppy} />
        </div>
      )}
      <div className="flex justify-between items-center mt-10">
        <Breadcrumb segments={state.segments} onNavigate={onNavigate} />
        <FolderControls category={category} code={code} />
      </div>
      <NoRowsWrapper
        className="aridhia-attachment-cards"
        icon="file alternate outline"
        entity="dataset.attachments"
        readErrors={[]}
        readStatus={[state.readStatus]}
        items={state.items}
        loading
      >
        <ScrollableCards itemsPerRow={1} className="mt-0">
          <DatasetAttachmentCardItems category={category} code={code} items={state.items} />
        </ScrollableCards>
      </NoRowsWrapper>
    </DatasetAttachmentsAccordion>
  );
};

export default DatasetAttachmentsCards;
